// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Button from "../html/Button.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Caml_array from "melange.js/caml_array.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import Cropperjs from "cropperjs";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function FileUploader2(Props) {
  let onChangeOpt = Props.onChange;
  let disabledButton = Props.disabledButton;
  const onChange = onChangeOpt !== undefined ? onChangeOpt : (function (param) {
      
    });
  const match = React.useState(function () {
    
  });
  const setValue = match[1];
  const value = match[0];
  const match$1 = React.useState(function () {
    return false;
  });
  const setDisabled = match$1[1];
  const disabled = match$1[0];
  const inputRef = React.useRef(null);
  const imageRef = React.useRef(null);
  const cropperRef = React.useRef(null);
  React.useEffect((function () {
    const imageEl = imageRef.current;
    if (imageEl == null) {
      return;
    }
    const crp = new Cropperjs(imageEl);
    crp.setAspectRatio(1);
    cropperRef.current = crp;
  }), [value]);
  return JsxRuntime.jsx("div", {
    children: value !== undefined ? JsxRuntime.jsxs(React.Fragment, {
        children: [
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("img", {
                ref: imageRef,
                src: value
              }),
              className: "h-80"
            }),
            className: "flex flex-col mx-auto h-88 justify-center gap-8 items-center w-94 rounded-sm text-center"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                kind: "default",
                type_: "button",
                className: "w-full",
                onClick: (function (param) {
                  Curry._1(setDisabled, (function (param) {
                    return !disabled;
                  }));
                  Curry._1(setValue, (function (param) {
                    
                  }));
                  Curry._1(onChange, undefined);
                }),
                children: "Загрузить другой файл"
              }),
              JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                type_: "button",
                className: "w-full disabled:bg-asphalt disabled:text-default-gray",
                disabled: disabled,
                onClick: (function (param) {
                  const cropperInstance = cropperRef.current;
                  if (cropperInstance == null) {
                    return;
                  }
                  const croppedCanvas = cropperInstance.getCroppedCanvas({fillColor: '#ffffff'});
                  const dataUrl = croppedCanvas.toDataURL("image/jpeg", 0.92);
                  cropperInstance.replace(dataUrl);
                  Curry._1(setDisabled, (function (param) {
                    return !disabled;
                  }));
                }),
                children: "Сохранить"
              })
            ],
            className: "border-t border-gray-main py-4 px-6 flex flex-col justify-between items-center gap-4 "
          })
        ]
      }) : JsxRuntime.jsxs(React.Fragment, {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "w-12 h-12",
                src: StaticAsset.src("/static/icons/upload-icon.svg")
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                    className: "text-gray-medium",
                    children: "Перенесите фото в эту область"
                  }),
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                      className: "mr-1 text-gray-medium",
                      children: [
                        "или ",
                        JsxRuntime.jsx("input", {
                          ref: inputRef,
                          className: "hidden",
                          type: "file",
                          onChange: (function (ev) {
                            let file = Caml_array.get(ev.target.files, 0);
                            const reader = new FileReader();
                            reader.readAsDataURL(file);
                            reader.onload = (function (param) {
                              const content = String(reader.result).replace(/^data:(.*,)?/g, "");
                              Curry._1(setValue, (function (param) {
                                return String(reader.result);
                              }));
                              Curry._1(onChange, content);
                            });
                          })
                        }),
                        JsxRuntime.jsx("button", {
                          children: "выберите файл",
                          className: "font-medium text-primary hover:text-primary-lite focus:outline-hidden focus:underline transition duration-150 ease-in-out",
                          type: "button",
                          onClick: (function (param) {
                            const __x = inputRef.current;
                            Belt__Belt_Option.map((__x == null) ? undefined : Caml_option.some(__x), (function (el) {
                              return el.click();
                            }));
                          })
                        })
                      ]
                    }),
                    className: "flex text-center justify-center"
                  }),
                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                    className: "text-gray-default",
                    children: "Jpeg или png размером не более 10 Мб"
                  })
                ],
                className: "flex flex-col"
              })
            ],
            className: "flex flex-col mx-auto my-4 h-80 justify-center gap-8 items-center border border-gray-main border-dashed w-94 rounded-sm text-center"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(Buhta_cabinet__Button.make, {
              type_: "button",
              className: "w-full disabled:bg-asphalt disabled:text-default-gray",
              disabled: disabledButton,
              children: "Сохранить"
            }),
            className: "border-t border-gray-main py-4 px-6 flex justify-between items-center gap-x-2 "
          })
        ]
      })
  });
}

const make = FileUploader2;

export {
  make,
}
/* Buhta_cabinet__Button Not a pure module */
